<template lang="pug">
div.web-ambiente
    el-row
        el-col.col-left(:span="15")
            .linha
                .bold Área:
                span {{ sugestaoWebAmbiente.areaTotal.toFixed(3) }} ha
            .linha
                .bold Bioma:
                span {{ BiomaEnum[sugestaoWebAmbiente.bioma].nome }}
            .linha
                .bold Estrutura de vegetação:
                span {{ sugestaoWebAmbiente.area.formacaoVegetal }}
            .linha
                .bold Fitofisionomia:
                span {{ sugestaoWebAmbiente.area.fitofisionomia }}
            .linha
                .bold Potencial de Regeneração:
                span {{ potencialRegeneracao }}
            .linha
                .bold Características do Solo:
                | {{ sugestaoWebAmbiente.area.texturaSolo }}
                | / {{ sugestaoWebAmbiente.area.profundidadeSolo }}
                | / {{ sugestaoWebAmbiente.area.drenagemSolo }}
                | / {{ sugestaoWebAmbiente.area.capacidadeSolo }}
            el-row
                .bold.titulo(v-if='sugestaoWebAmbiente.preparo.length > 0')
                    | AÇÕES SUGERIDAS PARA PREPARO INICIAL DA ÁREA
                el-row(v-for='(preparo, index) in sugestaoWebAmbiente.preparo' :key='index')
                    .linha
                        span {{ index + 1 }} - {{ preparo.acao }}
                            a(:href='getUrl(preparo.saibaMais)' target="_blank") Saiba mais.
            el-row
                .bold.titulo(v-if='sugestaoWebAmbiente.estrategias.length > 0')
                    | ESTRATÉGIAS SUGERIDAS PARA RECOMPOSIÇÃO COM ESPÉCIES NATIVAS
                el-row(v-html='sugestaoWebAmbiente.resultadoPotencial')
                .linha Estratégia(s) recomendada(s) para recompor a sua Área
                li.line-height(v-for='estrategia in sugestaoWebAmbiente.estrategias')
                    | {{ estrategia.nome }}.
                    a(:href='getUrl(estrategia.saibaMais)' target="_blank") Saiba mais.
        el-col#mapa-web-ambiente(:span="9")
            mapa-geo-car-wc(
                :id-imovel='$route.params.codigoImovelCriptografado',
                :sicar-url="urlSicar",
                :token='infoMapa.token'
                @loadded="handleMapaCarregado"
            )
    el-row(v-if='sugestaoWebAmbiente.especies.length > 0')
        .bold.titulo ESPÉCIES NATIVAS SUGERIDAS PARA PLANTIOS NA ÁREA A SER RECOMPOSTA
        span As seguintes espécies são recomendadas para a sua área. Entretanto, se a estratégia de
            | recomposição sugerida for apenas Regeneração Natural sem Manejo, esta lista indica principalmente
            | as espécies que devem ser monitoradas como regenerantes no ambiente em recomposição.
        .linha.line-height Número de espécies: {{ sugestaoWebAmbiente.especies.length }}
        el-table(:data="sugestaoWebAmbiente.especies" border stripe)
            el-table-column(prop="nome" label="Espécie")
            el-table-column(prop="nomePopular" label="Nome popular")
            el-table-column(prop="usoEconomico" label="Uso econômico")
            el-table-column(prop="estrategiaOcupacao" label="Estratégia de ocupação")
</template>

<script>
import { BiomaEnum } from '@/enums/imovel.enum.js';
import Mapa from '@/components/standard/Mapa.vue';
import BUS from '@/utils/bus.utils';

export default {
    components: {
        Mapa
    },
    props: {
        sugestaoWebAmbiente: {
            type: Object,
            required: true
        },
        infoMapa: {
            type: Object,
            required: true,
        }
    },
    data() {
        return {
            BiomaEnum,
            urlSicar: process.env.VUE_APP_SICAR_URL,
        }
    },
    computed: {
        potencialRegeneracao() {
            return this.sugestaoWebAmbiente.area.potencialRegeneracaoSolo.split('.')[0];
        },
    },
    mounted() {
        BUS.$emit('loading:show');
    },
    methods: {
        handleMapaCarregado(dadosMapa) {
            const grupos = dadosMapa.srcElement._wrapper.$refs.inner.mapaInfo.grupos;
            for (const grupo of grupos) {
                const areaEncontrada = grupo.areas.find(area => area.codigo === this.infoMapa.codigoArea);
                if (areaEncontrada) {
                    dadosMapa.srcElement._wrapper.$refs.inner.addGeoJsonToDrawnItems(areaEncontrada.geo);
                }
            }
            dadosMapa.srcElement._wrapper.$refs.inner.disableTools();
            setTimeout(() => {
                window.dispatchEvent(new Event('resize'));
            }, 600);
            BUS.$emit('loading:hide');
        },
        getUrl(url) {
            if (url.includes('gov.br')) {
                return url.replace('gov', 'cnptia.embrapa');
            }
            return url;
        }
    }
}

</script>

<style scoped>
.web-ambiente {
    padding: 12px;
    color: rgb(51, 51, 51);
    max-height: calc(100vh - 250px);
    overflow-y: auto;
}

.bold {
    font-weight: bold;
    padding-right: 5px;
}

.col-left {
    padding: 20px 20px 0px 0px;
}

#mapa-web-ambiente {
    padding: 30px 0px 0px 20px;
    height: 300px;
}

.titulo {
    padding: 20px 0px 10px 0px;
}

.web-ambiente::-webkit-scrollbar {
    width: 8px;
}

.web-ambiente::-webkit-scrollbar-thumb {
    border-radius: 100px;
    box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
}

.line-height {
    line-height: 1.3rem;
}

.linha {
    margin: 8px 0px;
}

a {
    color: blue;
    cursor: pointer;
}
</style>
